import { render } from "./ShipmentHistoryListing.vue?vue&type=template&id=45a72a6e&ts=true"
import script from "./ShipmentHistoryListing.vue?vue&type=script&lang=ts"
export * from "./ShipmentHistoryListing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__